export enum ComponentModesEnum {
  COMPONENT = 'component',
  MODAL = 'modal'
}
